export const AUTH_CONFIG = {
  domain: "schoolinthecloud.auth0.com",
  clientId: "5yZI7GHPwu4rDt3c4W4JYGM3I405ixqk",
  callbackUrl: process.env.REACT_APP_LOCAL || process.env.REACT_APP_PROD
  //=callbackUrl: "http://localhost:3000/callback"
};
